export default __webpack_public_path__ + "static/media/ayurvedic.f0826943.jpg";